import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../../commonComponents/translate';
import { getTeamName } from '../../../../challenges/details/info/Rewards';
import RewardProp from '../../../../sessions/propTypes/rewardProp';
import { newFormatPrice } from '../../../../../services/utilityFunctions';
import LockIcon from '../../../../../commonComponents/icons/LockIcon';

const renderContent = (t, type, reward, showRewards) => {
  let image = '';
  let custom = null;
  let content = '';
  let wrapperClass = '';
  let containerClass = '';

  switch (type) {
    case 'coins':
      wrapperClass = 'coins-section';
      containerClass = 'coins-icon-wrapper';
      image = '/images/shop/coins.svg';
      content = `${reward.coins || ''} ${t('challengeDetails.about.coins')}`;
      break;
    case 'userType':
      image = '/images/rewards/userType.svg';
      content = t(`user_type_${reward.userType}`);
      break;
    case 'userLevel':
      containerClass = 'userLevel-icon-wrapper';
      image = reward?.userSkillLevel?.icon || '';
      content = reward?.userSkillLevel?.name || '';
      break;
    case 'chatGroup':
      wrapperClass = 'chatGroup-container';
      containerClass = 'chatGroup-image';
      custom = (
        <div className="team-img">
          <span>
            {reward?.chatGroup?.name
              ? getTeamName(reward?.chatGroup?.name)
              : ''}
          </span>
        </div>
      );
      content = reward.chatGroup.name;
      break;
    case 'isTrainer':
      image = '/images/rewards/trainer.svg';
      wrapperClass = 'trainer-container';
      content = t('trainer');
      break;
    case 'isOperator':
      image = '/images/rewards/operator.svg';
      wrapperClass = 'trainer-container';
      content = t('operator');
      break;
    case 'couponDiscount': {
      const {
        name = 'Discount Coupon',
        expirationDate,
        amountOffAvailable,
        userPrice,
        currency,
        percentOff,
      } = reward?.couponDiscount?.existentCouponId || {};
      let couponValue;
      if (amountOffAvailable) {
        const currencyToUse = userPrice ? userPrice.code : currency;
        couponValue = `${newFormatPrice(
          amountOffAvailable,
          true,
          currencyToUse,
        )}`;
      } else {
        couponValue = `${percentOff}%`;
      }
      image = '/images/shop/coupon.svg';
      wrapperClass = 'coupon-discount-container';
      containerClass = 'coupon-discount-image-container';
      content = (
        <div className="coupon-discount">
          <div className="coupon-info">
            <p className="coupon-name">{name}</p>
            <p className="coupon-value">{couponValue}</p>
          </div>
          {expirationDate && (
            <>
              <div className="coupon-separator" />
              <div className="coupon-validation">
                <p className="coupon-valid-label">
                  {t('reward.couponDiscount.validUntil')}
                </p>
                <p className="coupon-valid-value">
                  {moment(expirationDate).format('DD MMM YYYY')}
                </p>
              </div>
            </>
          )}
        </div>
      );
      break;
    }
    case 'coupon': {
      const { name = 'Voucher Coupon', image: voucherImage } =
        reward?.coupon || {};
      wrapperClass = 'voucher-reward-wrapper';
      containerClass = 'voucher-container-image';
      image = voucherImage?.thumb || '/images/shop/coupon.svg';
      content = name;
      custom = (
        <div style={{ position: 'relative' }}>
          {!showRewards && (
            <div className="lock-container">
              <LockIcon width={40} height={40} color="#B0B0B0" />
            </div>
          )}
          <img
            className={`reward ${!showRewards && 'blocked'}`}
            src={image}
            alt={type}
          />
        </div>
      );
      break;
    }
    default:
      return <div />;
  }

  return (
    <div className={`${wrapperClass} reward-wrapper-class`}>
      <div className={`${containerClass} reward-container-class`}>
        {!custom ? <img src={image} alt={type} /> : custom}
      </div>
      <div>{content}</div>
    </div>
  );
};

function RewardJourneyCard(props) {
  const { t, type, reward, isFinished } = props;
  return (
    <div className="reward-wrapper">
      <p className="title">{t(`reward.${type}`)}</p>
      <div className="reward-card-container">
        {renderContent(t, type, reward, isFinished)}
      </div>
    </div>
  );
}

RewardJourneyCard.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  reward: PropTypes.shape(RewardProp.propType).isRequired,
  isFinished: PropTypes.bool,
};

RewardJourneyCard.defaultProps = {
  isFinished: false,
};

export default translate(RewardJourneyCard);
